<div class="flex flex-column">

  <div>
    <app-input type="label" label="Id" [model]="group.aclGroupId || '<Nuovo>'"></app-input>
    <br>

    <app-input type="text" [maxLength]="32" label="Nome del gruppo" [(model)]="group.name"></app-input>
    <br>
    <app-input type="textarea" [maxLength]="128" label="Descrizione" [(model)]="group.description"></app-input>
    <br>
    <app-dropdown label="Utenti" [(model)]="selectedUsers" [dropdownItems]="users" optionLabel="username"
                  [showFilter]="true" [multiple]="true"></app-dropdown>
    <br>
    <br>
    <app-checkbox-list [items]="permissions" [selectedItems]="selectedPermissions" [filterable]="true"
                       groupName="category" optionLabel="description" optionValue="id"
                       [isGrouped]="true"></app-checkbox-list>
    <br>
  </div>

  <div class="grid">
    <div class="col-6">
      <button pButton class="p-button-outlined" icon="pi pi-times" label="Annulla" (click)="close()"></button>
    </div>
    <div class="col-6">
      <button pButton class="p-button-raised" icon="pi pi-save" label="Salva" (click)="save()"
              style="float: right"></button>
    </div>
  </div>
</div>
